import { type RouteLocationNormalized, type RouteRecordRaw } from 'vue-router'

import { isChromeLessIframeSession } from '@/auth/iframeSession'
import { appStoreRouter } from '@/features/app-store/router/appStore.router'
import { billingRouter } from '@/features/billing/router/billing.router'
import { brandKitRouter } from '@/features/brand-kit/router/brandKit.router'
import { brandStatusRouter } from '@/features/brand-status/router/brandStatus.router'
import { customerAnalyticsRouter } from '@/features/customerAnalytics/router/customerAnalytics.router'
import { customersRouter } from '@/features/customers/router/customers.router'
import { deliveryRouter } from '@/features/delivery/router/delivery.router'
import { domainsRouter } from '@/features/domains/router/domains.router'
import { eventsRouter } from '@/features/events/router/events.router'
import { formBuilderRoutes } from '@/features/form-builder/router/formBuilder.router'
import { giftCardsRouter } from '@/features/gift-cards/router/giftCards.router'
import { homeRouter } from '@/features/home/router/home.router'
import { hoursRouter } from '@/features/hours/router/hours.router'
import { inboxRouter } from '@/features/inbox/router/inbox.router'
import { launchOnboardingRouter, launchRouter } from '@/features/launch'
import { marketingRouter } from '@/features/marketing/router/marketing.router'
import { menuRouter } from '@/features/menu/router/menu.router'
import { menuFixerAgentRouter } from '@/features/menu-fixer-agent/router/menuFixerAgent.router'
import { ordersRouter } from '@/features/orders/router/orders.router'
import { ownerPaymentsRouter } from '@/features/owner-payments/router/ownerPayments.router'
import { printShopEmbedRouter } from '@/features/print-shop-embed/router/printShopEmbed.router'
import { brandReportRoutes } from '@/features/reports/router/reports.router'
import { brandReportingV2Routes } from '@/features/reports-v2/router/reports-v2.router'
import { reviewsRouter } from '@/features/reviews/router/reviews.router'
import { salesRouter } from '@/features/sales/router/sales.router'
import { seoRouter } from '@/features/seo/router/seo.router'
import { settingsRouterBrand } from '@/features/settings/router/settings.router'
import { setupRouter } from '@/features/setup/router/setup.router'
import { staffRouter } from '@/features/staff/router/staff.router'
import { phoneRouter, toolsRouter } from '@/features/tools/router/tools.router'
import { websiteBuilderRouter } from '@/features/website-builder/router/websiteBuilder.router'

import { locationRoutes } from './locationRoutes'
import {
  isEmbeddedBrandRoute,
  isWrapperlessBrandRouteName,
} from './wrapperlessBrandRoutes'

export const brandRoutes: RouteRecordRaw[] = [
  {
    children: [
      {
        path: '',
        redirect: { name: 'brand.home' },
      },
      ...homeRouter,
      ...setupRouter,

      ...brandReportRoutes,
      ...brandReportingV2Routes,

      ...menuRouter,
      ...menuFixerAgentRouter,
      ...ordersRouter,
      ...inboxRouter,
      ...giftCardsRouter,
      {
        component: async () =>
          import('@/features/careers/views/CareersHestiaRouteView.vue'),
        meta: {
          authZ: ({ user }) => user.can('read', 'career'),
          redirectToLocation: true,
          title: 'restaurant.careers',
        },
        name: 'brand.careers',
        path: 'careers',
      },
      ...eventsRouter,
      ...hoursRouter,
      ...deliveryRouter,
      ...reviewsRouter,

      ...marketingRouter,
      ...printShopEmbedRouter,

      {
        children: [...websiteBuilderRouter, ...formBuilderRoutes],
        component: {
          name: 'WebsiteBuilderRouterView',
          template: '<router-view></router-view>',
        },
        name: 'brand.website',
        path: 'website',
        redirect: { name: 'brand.website.pages.home' },
      },
      ...domainsRouter,
      ...customerAnalyticsRouter,

      ...appStoreRouter,

      ...customersRouter,

      ...phoneRouter,
      ...toolsRouter,
      ...seoRouter,

      ...billingRouter,
      ...ownerPaymentsRouter,
      ...settingsRouterBrand,

      ...salesRouter,
      ...launchRouter,
      ...launchOnboardingRouter,
      ...brandKitRouter,
      ...brandStatusRouter,
      ...locationRoutes,
      ...staffRouter,
    ],
    component: async () => await import('@/views/BrandView/BrandView.vue'),
    path: 'brands/:brandId',
    props: (route: RouteLocationNormalized) => ({
      brandId: route.params.brandId,
      wrapperless:
        isWrapperlessBrandRouteName(route.name) ||
        isEmbeddedBrandRoute(route.query, isChromeLessIframeSession()),
    }),
  },
]
